module.exports = __webpack_public_path__ + "static/media/blog-wild-dev.6b1c4fb0.png";